export default "__VITE_ASSET__B3pKk7OV__"